module.exports = __webpack_public_path__ + "static/04 - HEC-2d656d3a4c84fd600725a85692187198.png";